import { useMutation } from "react-query";

import { httpService } from "utils";

import { useGetAuthorizationStore } from "./useGetAuthorizationStore";
import { createChannel } from "../../../utils/hooks/createChannel";
import { UserAction } from "../application/types/UserAction";

export const useLogoutUser = () => {
  const channel = createChannel("USER_ACTION");
  const { userId, deleteAuthorization } = useGetAuthorizationStore((state) => ({
    userId: state.userId,
    deleteAuthorization: state.deleteAuthorization,
  }));

  if (!userId) {
    throw new Error("UserId not found");
  }

  return useMutation(() => {
    return logoutUser(userId).then(async (res) => {
      deleteAuthorization();
      await channel.postMessage(UserAction.Logout);
      await channel.close();
      return res;
    });
  });
};

const logoutUser = (userId: string) => {
  return httpService().post(`/user/${userId}/log-out`);
};
